// extracted by mini-css-extract-plugin
export default {"breadcrub_container":"index_breadcrub_container__4GsR8","createdSearch":"index_createdSearch__OJE64","custom_table":"index_custom_table__6vwQF"};